export default {
  salesIndicator: {},
  awaitingExportSalesIndicator: {},
  expensesIndicator: {},
  awaitingExportExpensesIndicator: {},
  hrIndicator: {},
}